import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";

class NewYearGoalForm extends Component {

    componentDidMount() {
        const { plugin, onChange } = this.props
        if (!plugin.active) {
            onChange({
                setting: {
                    entryCnt: 0,
                    commentCnt: 0,
                    guestbookCnt: 0,
                    visitCnt: 0
                },
                validated: false
            })
        }
    }

    validate(setting) {
        const { entryCnt, commentCnt, guestbookCnt, visitCnt } = setting
        return entryCnt > 0 && commentCnt > 0 && guestbookCnt > 0 && visitCnt > 0
    }

    @autobind
    handleChangeEntryCount(value) {
        const { onChange, data } = this.props
        let newData = update(data, {
            setting: {
                entryCnt: {
                    $set: value
                },
            }
        })

        onChange(update(newData, {
            validated: {
                $set: this.validate(newData.setting)
            }
        }))
    }

    @autobind
    handleChangeCommentCount(value) {
        const { onChange, data } = this.props
        let newData = update(data, {
            setting: {
                commentCnt: {
                    $set: value
                },
            }
        })

        onChange(update(newData, {
            validated: {
                $set: this.validate(newData.setting)
            }
        }))
    }

    @autobind
    handleChangeGuestbookCount(value) {
        const { onChange, data } = this.props
        let newData = update(data, {
            setting: {
                guestbookCnt: {
                    $set: value
                },
            }
        })

        onChange(update(newData, {
            validated: {
                $set: this.validate(newData.setting)
            }
        }))
    }

    @autobind
    handleChangeVisitCount(value) {
        const { onChange, data } = this.props
        let newData = update(data, {
            setting: {
                visitCnt: {
                    $set: value
                },
            }
        })

        onChange(update(newData, {
            validated: {
                $set: this.validate(newData.setting)
            }
        }))
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin45">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        스킨 치환자는 <span className="txt_em">[##_BLOG_GOAL_##]</span>
                        입니다.
                    </div>
                </div>

                <fieldset>
                    <legend className="tit_set">블로그 목표 설정</legend>
                    <dl className="list_write">
                        <dt><label htmlFor="tfWrite1">글</label></dt>
                        <dd className="follow_write">
                            <TInputForm type="text" id="tfWrite1" className="tf_set" value={data.setting.entryCnt} onChange={this.handleChangeEntryCount} /> 개 작성
                        </dd>
                        <dt><label htmlFor="tfWrite2">댓글</label></dt>
                        <dd>
                            <TInputForm type="text" id="tfWrite2" className="tf_set" value={data.setting.commentCnt} onChange={this.handleChangeCommentCount} /> 개 작성
                        </dd>
                        <dt><label htmlFor="tfWrite3">방명록</label></dt>
                        <dd className="follow_write">
                            <TInputForm type="text" id="tfWrite3" className="tf_set" value={data.setting.guestbookCnt} onChange={this.handleChangeGuestbookCount} /> 개 작성
                        </dd>
                        <dt><label htmlFor="tfWrite4">방문자</label></dt>
                        <dd>
                            <TInputForm type="text" id="tfWrite4" className="tf_set" value={data.setting.visitCnt} onChange={this.handleChangeVisitCount} /> 명 작성
                        </dd>
                    </dl>
                </fieldset>
                {this.props.saveButton()}
            </div>
        )
    }
}

NewYearGoalForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default NewYearGoalForm
